module.exports = __webpack_public_path__ + "img/number-06.54bd7471.png";